import { ValidatorFn, AbstractControl } from '@angular/forms';

export function rateAmountValidator(maxAmount: any): ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {

    if (control.value !== null) {
        const rateAmount = control.value;
        if (+rateAmount > +maxAmount) {
            return{ rateAmt1 : true};
        }
    }
    return null;
    };
}

export function minChargeValidator(minAmount: any): ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {

        if (control.value !== null) {
            const minCharge = control.value;
            if (+minCharge < +minAmount) {
                return{ minAmt1 : true};
            }
        }
        return null;
    };

}
